let storeConfig = {}; // 存储组件临时配置

function getStoreConfig() {
  return storeConfig;
}
function setStoreConfig(value) {
  storeConfig = value;
}
export {
  getStoreConfig,
  setStoreConfig
};
